module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"text":"微信扫码打开小程序，随时随地查看个人文件"},"en":{"text":"Scan the QR code on WeChat to open the mini program to personal files anytime, anywhere"},"id":{"text":"Pindai kode QR di WeChat untuk membuka program mini dan melihat file pribadi kapan saja dan di mana saja"}}')
  delete Component.options._Ctor
}
